import React, { CSSProperties, FC } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import IconButton from '@mui/material/IconButton'
import edit from 'sources/imagesPWA/edit.svg'
import arrow from 'sources/imagesPWA/arrow.svg'

import { SxProps } from '@mui/material'

import styles from './styles.module.scss'

enum ICONS {
  edit = 'edit',
  arrowUp = 'arrowUp',
  arrowRight = 'arrowRight',
  arrowDown = 'arrowDown',
  arrowLeft = 'arrowLeft'
}

const getIcon = (icon: ICONS) => {
  switch (icon) {
    case ICONS.edit:
      return edit
    case ICONS.arrowUp:
    case ICONS.arrowRight:
    case ICONS.arrowDown:
    case ICONS.arrowLeft:
      return arrow
  }
}

type RGB = `rgb(${number}, ${number}, ${number})`;
type RGBA = `rgba(${number}, ${number}, ${number}, ${number})`;
type HEX = `#${string}`;
type VAR = `var(--${string})`;

type Color = RGB | RGBA | HEX | VAR;

interface IProps {
  icon: keyof typeof ICONS
  onClick: () => void
  buttonSX?: SxProps
  buttonHoverBG?: Color
  iconStyle?: CSSProperties
}


export const IconButtonPWA: FC<IProps> = ({ onClick, icon, iconStyle, buttonSX, buttonHoverBG }) => {

  const iconImage = getIcon(icon as ICONS)

  const arrowRotateStyle = (icon: ICONS) => {
    switch (icon) {
      case ICONS.arrowUp:
        return ({transform: 'rotate(-90deg)'})
      case ICONS.arrowRight:
        return ({})
      case ICONS.arrowDown:
        return ({transform: 'rotate(90deg)'})
      case ICONS.arrowLeft:
        return ({transform: 'rotate(180deg)'})
    }
  }
  return (
    <IconButton
      color="inherit"
      aria-label={icon}
      onClick={onClick}
      sx={{
        '&:hover': {
          backgroundColor: buttonHoverBG
        },
        width: '28px',
        height: '28px',
        padding: '2px',
        ...buttonSX
      }}
      size="large">
      <div className={styles.icon}
           style={{
             WebkitMaskImage: `url(${iconImage})`,
             maskImage: `url(${iconImage})`,
             width: '100%',
             height: '100%',
             ...arrowRotateStyle(icon as ICONS),
             ...iconStyle
           }}
      />
    </IconButton>
  );
}
